<ng-template #editTagModal let-modal>
    <form class="kt-form form-horizontal" name="form" (ngSubmit)="submit(f)" #f="ngForm" novalidate>
        <div *blockUI="'container-blockui-recurrance-popup'">
            <div class="modal-header">
                <h5 class="modal-title">Edit Kiosk Tag</h5>
                <button type="button" class="close" aria-label="Close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group row" [ngClass]="{ 'validation-error' : f.submitted && kioskTag.invalid}">
                    <div class="col-12">
                        <input type="text" name="kioskTag" class="form-control" autocomplete="off" [(ngModel)]="tag"
                            #kioskTag="ngModel" required appAlphabatesWithNumberAndSpaceOnly required />
                    </div>
                    <div class="col-12 validation-error-message" *ngIf="f.submitted && kioskTag.invalid">
                        Tag is required
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="col-md-12 text-right">
                    <button type="button" class="btn btn-default m-r-5" (click)="close()">Cancel</button>
                    <button type="submit" class="btn btn-primary">Submit</button>
                </div>
            </div>
        </div>
    </form>
</ng-template>